import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_inventory_count_all_fieldsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { inventoryCountId: number }): 
  Promise<{ result: { Id?: number, Description?: string, InventoryCountAggregationItems?: number, InventoryCountBlindItems?: number, InventoryCountEnabled?: boolean, InventoryCountGroupPackages?: boolean, InventoryCountLocationValidation?: boolean, InventoryCountRequestSerialNumbers?: boolean, InventoryCountTryScanOnlyEditor?: boolean, LocationFilter?: string, LookupCode?: string, LpInventoryCountEnabled?: boolean, LpInventoryCountRequestLookupCode?: boolean, MaterialFilter?: string, ScheduleId?: string, StatusId?: number, WarehouseId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountId)) {
      $missingRequiredInParams.push('\'inventoryCountId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      inventoryCountId: number    }) {
        if(isNil($inParams.inventoryCountId)) {
          return true; 
        }
      return false;
    }
}
